// extracted by mini-css-extract-plugin
module.exports =  {"List":"fPV3yu1ii9sjdBY7n4Sk"};